import ShiftPage from './ShiftPage';

export default ShiftPage;
